import "../../style.css";
import { useState, useEffect, useCallback, useMemo } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogContentText } from "@mui/material";
import { MdClear } from 'react-icons/md';

import { AgGridReact } from "ag-grid-react";
import CustomPagination from "../../../../components/CustomPagination";
import TableSkeleton from "../../../../components/table/TableSkeleton.js";

import {
  saveUpdateReimburse,
  initReimburseState,
} from "../../../../redux/slices/reimbursementSlice";
import {
  getReimbursementPayrollEmployeePath,
  calculateEarnedSalaryPath,
  addReimbursementStaffPath,
} from "../../../../services/config";

import {
  fetchBranchData,
  initBranchState,
} from "../../../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../../redux/slices/departmentSlice";
import {
  fetchData,
  initShiftState,
} from "../../../../redux/slices/shiftsSlice";

import {
  commonSaveData,
  initCommonState,
} from "../../../../redux/slices/commonSlice";

import { useDispatch, useSelector } from "react-redux";
import { Height } from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import Widgets from "../../../../components/Widgets/index.js";
import { HasPermission } from "../../../../services/hasPermission.js";
import {
  getInitials,
  getInitialColor,
  getCapitalizeWord,
  formatIndianAmountType
} from "../../../../services/commonServices.js";

const Reimbursement = () => {
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user_data")) || {};

  const branchState = useSelector((state) => state.branch);
  const departState = useSelector((state) => state.department);
  const shiftState = useSelector((state) => state.shift);
  const reimburseStore = useSelector((state) => state.reimburse);
  const commonStore = useSelector((state) => state.common);

  const getData = useCallback(() => {
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchDepartmentData(user.user_id));
    dispatch(fetchData(user.user_id));
  }, []);

  const [reimbursementList, setReimbursementList] = useState([]);
  const [reimbursementListOne, setReimbursementListOne] = useState([]);
  const [branch, setBranch] = useState([]);
  const [depart, setDepart] = useState([]);
  const [shift, setShift] = useState([]);
  const [maxMonth, setMaxMonth] = useState("");
  const [open, setOpen] = useState(false);

  // State for storing totals
  const [grandTotals, setGrandTotals] = useState({
    totalCTC: 0,
    totalPayrollFinalized: 0,
    totalReimbursement: 0,
  });

  const [state, setState] = useState({
    payrollMonth: "",
    branch: "",
    shiftId: "",
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const handelChange = ({ target: { name, value } }) => {
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Calculate grand totals from reimbursement list
  const calculateGrandTotals = useCallback((dataList) => {
    if (!Array.isArray(dataList) || dataList.length === 0) {
      setGrandTotals({
        totalCTC: 0,
        totalPayrollFinalized: 0,
        totalReimbursement: 0,
      });
      return;
    }

    const totals = dataList.reduce((acc, item) => {
      const ctc = parseFloat(item.CostToCompany) || 0;
      acc.totalCTC += ctc;
      
      const payrollFinalized = parseFloat(item.payrollFinalized) || 0;
      acc.totalPayrollFinalized += payrollFinalized;
      
      const reimbursement = parseFloat(item.salaryCountDays?.reimburseAmount) || 0;
      acc.totalReimbursement += reimbursement;
      
      return acc;
    }, {
      totalCTC: 0,
      totalPayrollFinalized: 0,
      totalReimbursement: 0,
    });

    setGrandTotals(totals);
  }, []);

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const currentMonth = `${year}-${month}`;
    setMaxMonth(currentMonth);
    setState((prev) => ({
      ...prev,
      payrollMonth: currentMonth,
    }));
  }, []);

  useEffect(() => {
    if (state.payrollMonth) {
      getReimbursePayroll();
    }
  }, [state.payrollMonth, state.branch, state.shiftId]);

  const getReimbursePayroll = () => {
    if (state.payrollMonth) {
      const data = {
        path: calculateEarnedSalaryPath,
        data: {
          userId: user.user_id,
          selectedDate: `${state.payrollMonth}-01`,
          branchId: state.branch || null,
          shiftId: state.shiftId || null,
        },
      };
      dispatch(commonSaveData(data));
    }
  };

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      setBranch(branchState.brnGetData);
      dispatch(initBranchState());
    }

    if (departState.depGetSuccess) {
      setDepart(departState.depGetData);
      dispatch(initDepartState());
    }

    if (shiftState.shiftGetSuccess) {
      setShift(shiftState.shiftGetData);
      dispatch(initShiftState());
    }

    if (reimburseStore.reimburseSuccess) {
      toast.success(reimburseStore.reimburseMessage);
      toggleInActive();
      dispatch(initReimburseState());
      getReimbursePayroll();

      setReimburseStaff((prev) => ({
        ...prev,
        amount: "",
        paymentDate: "",
        notes: "",
        staffId: addPreReimburse.staffId,
      }));
    }

    if (commonStore.commonSuccess) {
      if (commonStore.commonData) {
        if (searchQuery !== "") {
          searchEmployees(searchQuery, commonStore.commonData?.staffDetails);
        } else {
          const staffDetails = commonStore.commonData?.staffDetails || [];
          setReimbursementList(staffDetails);
          setReimbursementListOne(staffDetails);
          calculateGrandTotals(staffDetails);
          toggleInActive();
          getData();
        }
      }
      dispatch(initCommonState());
    }

    if (commonStore.commonError) {
      setReimbursementList([]);
      setGrandTotals({
        totalCTC: 0,
        totalPayrollFinalized: 0,
        totalReimbursement: 0,
      });
      toggleInActive();
      dispatch(initCommonState());
    }
  }, [branchState, departState, shiftState, reimburseStore, commonStore]);

  useEffect(() => {
    calculateGrandTotals(reimbursementList);
  }, [reimbursementList, calculateGrandTotals]);

  const date = new Date();
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "long" });

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  const columns = useMemo(
    () => [
      {
        headerName: "SNo",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 60,
        pinned: "left",
      },
      {
        headerName: "Employee ID",
        field: "employeeId",
        pinned: "left",
        width: 120,
      },
      {
        headerName: "Name",
        filter: true,
        width: "350px",
        cellRenderer: (row) => {
          const staffName = row.data.staffName || "";
          return (
            <span className="table-link d-flex align-items-center justify-content-start gap-2">
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  border: "1px solid lightgray",
                  borderRadius: "50%",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: getInitialColor(staffName),
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                {getInitials(staffName)}
              </div>
              {getCapitalizeWord(staffName)}
            </span>
          );
        },
      },
      {
        headerName: "Job title",
        field: "jobTitle",
        filter: true,
      },
      {
        headerName: "CTC",
        field: "ctc",
        filter: true,
        cellRenderer: (row) => {
          const ctcValue = row.data.CostToCompany ? parseFloat(row.data.CostToCompany) : 0;
          return (
            <span className="font-weight-500">
              {ctcValue > 0 ? formatIndianAmountType(ctcValue) : "-"}
            </span>
          );
        },
      },
      {
        headerName: "Payroll Finalized",
        field: "payrollFinalized",
        filter: true,
        cellRenderer: (row) => {
          const payrollValue = row.data.payrollFinalized ? parseFloat(row.data.payrollFinalized) : 0;
          return (
            <span className={payrollValue > 0 ? "text-success" : "text-warning"}>
              {payrollValue > 0 ? formatIndianAmountType(payrollValue) : "No"}
            </span>
          );
        },
      },
      {
        headerName: "Total Reimbursement",
        filter: true,
        cellRenderer: (row) => {
          const reimburseAmount = row.data.salaryCountDays?.reimburseAmount 
            ? parseFloat(row.data.salaryCountDays.reimburseAmount) 
            : 0;
          return (
            <span className={reimburseAmount > 0 ? "text-info font-weight-500" : ""}>
              {reimburseAmount > 0 ? formatIndianAmountType(reimburseAmount) : "-"}
            </span>
          );
        },
      },
      {
        headerName: "Actions",
        cellRenderer: (row) => {
          return HasPermission("Reimbursement", "create") ? (
            <div>
              <span
                onClick={() => addReimbursement(row.data)}
                style={{ color: "#8234db", cursor: "pointer" }}
              >
                Add Reimbursement
              </span>
            </div>
          ) : (
            "-"
          );
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: "200px",
      },
    ],
    []
  );

  const [isActive, setIsActive] = useState(false);
  const [addPreReimburse, setAddPreReimburse] = useState({});

  const addReimbursement = (data) => {
    setAddPreReimburse(data);
    setIsActive(true);
  };

  const toggleInActive = () => {
    setIsActive(false);
    setAddPreReimburse({});
  };

  const [reimburseStaff, setReimburseStaff] = useState({
    userId: user.user_id,
    staffId: "",
    amount: "",
    paymentDate: "",
    notes: "",
  });

  useEffect(() => {
    setReimburseStaff(prev => ({
      ...prev,
      staffId: addPreReimburse.staffId || ""
    }));
  }, [addPreReimburse]);

  const handleTypeChange = ({ target: { name, value } }) => {
    setReimburseStaff((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handelSaveReimburseStaff = () => {
    if (!reimburseStaff.staffId) {
      toast.error("No employee selected");
      return;
    }
    
    const data = {
      path: addReimbursementStaffPath,
      data: reimburseStaff,
    };
    dispatch(saveUpdateReimburse(data));
  };

  const filterRecord = ({ target: { checked } }) => {
    if (checked) {
      const array = reimbursementListOne.filter(
        (item) => item.status === "Active"
      );
      setReimbursementList(array);
    } else {
      setReimbursementList(reimbursementListOne);
    }
  };

  const searchEmployees = (value, dataList) => {
    setSearchQuery(value);
    const filteredEmployees = dataList.filter((v) =>
      v.staffName.toLowerCase().includes(value.toLowerCase()) ||
      (v.employeeId && v.employeeId.toLowerCase().includes(value.toLowerCase()))
    );
    setReimbursementList(filteredEmployees);
    setReimbursementListOne(dataList);
  };

  const resetFilter = () => {
    setReimbursementList(reimbursementListOne);
    setSearchQuery("");
    const checkbox = document.querySelector("#filterCheckbox");
    if (checkbox) {
      checkbox.checked = false;
    }
  };

  const clearFilter = () => {
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = String(date.getMonth() + 1).padStart(2, "0");
    
    const data = {
      path: calculateEarnedSalaryPath,
      data: {
        userId: user.user_id,
        selectedDate: `${currentYear}-${currentMonth}-01`,
        branchId: "",
        shiftId: "",
      },
    };
    dispatch(commonSaveData(data));

    setSearchQuery("")
    setState((prev) => ({
      ...prev,
      payrollMonth: `${currentYear}-${currentMonth}`,
      branch: "",
      shiftId: "",
      departmentId: "",
    }));
  };

  const getCurrentMonthYear = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  return (
    <div>
      <div
        style={{
          position: "fixed",
          width: "calc(100% - 20px)",
          height: "100%",
          zIndex: "1",
          marginTop: "10px",
        }}
      >
        <Widgets
          body={
            <Row>
              <Col sm="12">
                <div className="d-flex align-items-center justify-content-start gap-3 px-3 mt-3">
                  <Form.Group>
                    <Form.Control
                      name="searchQuery"
                      value={searchQuery}
                      onChange={(e) => searchEmployees(e.target.value, reimbursementListOne)}
                      placeholder="Search by Name or Employee ID"
                      style={{ width: "350px" }}
                      className="universal-input"
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Control
                      type="month"
                      name="payrollMonth"
                      value={state.payrollMonth}
                      onChange={handelChange}
                      max={maxMonth}
                      className="universal-input"
                      style={{ width: "180px" }}
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Select
                      name="branch"
                      value={state.branch}
                      onChange={handelChange}
                      className="universal-input"
                      style={{ width: "200px" }}
                    >
                      <option value="">All Branches</option>
                      {branch.map((row, idx) => (
                        <option value={row.branchId} key={idx}>
                          {row.branch_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group>
                    <Form.Select
                      name="shiftId"
                      value={state.shiftId}
                      onChange={handelChange}
                      className="universal-input"
                      style={{width: "180px"}}
                    >
                      <option value="">All Shifts</option>
                      {shift.map((row, idx) => (
                        <option value={row.shiftId} key={idx}>
                          {row.shiftName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group>
                    {(searchQuery ||
                      state.payrollMonth !== getCurrentMonthYear() ||
                      state.shiftId ||
                      state.departmentId ||
                      state.branch) && (
                      <button 
                        type="button" 
                        className="clear" 
                        onClick={clearFilter}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px'
                        }}
                      >
                        <MdClear /> Clear Filters
                      </button>
                    )}
                  </Form.Group>
                </div>

                <div
                  className="ag-theme-quartz custom-grid"
                  style={{
                    height: "calc(100vh - 290px)",
                    width: "100%",
                    padding: "10px 20px",
                    paddingRight: "40px",
                  }}
                >
                  {commonStore.commonLoading ? (
                    <TableSkeleton />
                  ) : (
                    <AgGridReact
                      rowData={Array.isArray(reimbursementList) ? reimbursementList : []}
                      columnDefs={columns}
                      defaultColDef={{
                        cellStyle: { fontSize: "14px" },
                      }}
                      pagination={true}
                      paginationPageSize={paginationPageSize}
                      onGridReady={onGridReady}
                    />
                  )}
                </div>

                {/* Grand Totals Section Only */}
                <div className="d-flex align-items-center justify-content-between custom-pagination px-2 py-2">
                  {gridApi && <CustomPagination gridApi={gridApi} />}
                  
                  <div className="d-flex align-items-center justify-content-start gap-3 color-white">
                    <span className="font-weight-500">Grand Totals</span>
                    <div className=" p-2 ">
                      <div className=" font-weight-500  flex-column">
                        <small className="">Total : ₹{formatIndianAmountType(grandTotals.totalCTC)}</small>
                        {/* <small className="text-muted">Total Reimbursement: ₹{formatIndianAmountType(grandTotals.totalReimbursement)}</small> */}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          }
        />

        <Dialog
          open={isActive}
          keepMounted
          onClose={toggleInActive}
          maxWidth="xs"
          fullWidth
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="dark-bg-color"
        >
          <DialogTitle className="dialog-title">
            <div className="dialog-title-icon">
              <span className="close-icon" onClick={toggleInActive}>
                X
              </span>
              <span className="title">Add Reimbursement</span>
            </div>
            <button className="universal-btn" onClick={handelSaveReimburseStaff}>
              Add
            </button>
          </DialogTitle>
          <DialogContent className="pure-dark-bg-color">
            <Form className="mt-3 px-2">
              <Form.Group className="mt-2">
                <span style={{ marginRight: "14px" }}>Amount</span>
                <Form.Control
                  name="amount"
                  value={reimburseStaff.amount}
                  onChange={handleTypeChange}
                  placeholder="0"
                  className="universal-input mt-2"
                  type="number"
                  min="0"
                  step="0.01"
                />
              </Form.Group>

              <Form.Group className="mt-2">
                <span style={{ marginRight: "5px" }}>Payment Date</span>
                <Form.Control
                  type="date"
                  max={new Date().toISOString().split("T")[0]}
                  name="paymentDate"
                  value={reimburseStaff.paymentDate}
                  onChange={handleTypeChange}
                  placeholder="select date"
                  className="universal-input mt-2"
                />
              </Form.Group>

              <Form.Group className="mt-2">
                <span style={{ marginRight: "26px" }}>Notes</span>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="notes"
                  name="notes"
                  value={reimburseStaff.notes}
                  onChange={handleTypeChange}
                  style={{ height: "100px" }}
                  className="universal-input mt-2"
                />
              </Form.Group>
            </Form>
          </DialogContent>
        </Dialog>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
      
      <style jsx>{`
        .summary-card {
          background: rgba(255, 255, 255, 0.05);
          min-width: 250px;
        }
        
        .font-12 {
          font-size: 12px;
        }
        
        .font-14 {
          font-size: 14px;
        }
        
        .text-muted {
          color: #6c757d !important;
        }
        
        .text-success {
          color: #28a745 !important;
        }
        
        .text-warning {
          color: #ffc107 !important;
        }
        
        .text-info {
          color: #17a2b8 !important;
        }
        
        .clear {
          background: transparent;
          border: 1px solid #6c63ff;
          color: #6c63ff;
          padding: 8px 8px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .clear:hover {
          background: #6c63ff;
          color: white;
        }
        
        .rounded {
          border-radius: 8px !important;
        }
      `}</style>
    </div>
  );
};

export default Reimbursement;